import React, { useState, useEffect, useRef } from "react";
import "./Chat.css";
import { IconButton } from "@material-ui/core";

import Message from "../Message/Message";
import { selectChatName, selectChatId } from "../../Redux/chatSlice";
import { useSelector } from "react-redux";
import db from "../../Config/firebase";
import firebase from "firebase";
import { selectUser } from "../../Redux/userSlice";
import FlipMove from "react-flip-move";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MenuIcon from "@material-ui/icons/Menu";
import SendIcon from '@material-ui/icons/Send';


const Chat = ({ handleOpen }) => {      //handle open because when we open or click on that group then this chat will open
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const [input, setInput] = useState("");
  const chatName = useSelector(selectChatName);  //To--{chatName}
  const chatId = useSelector(selectChatId);//to select chat id
  const user = useSelector(selectUser);//to select particular user,and also to use this to see which user send wich message and clicking that user we ger caht of that user  
  const [messages, setMessages] = useState([]); //this for that when we click on particular group then that group chat should open
  const ref = useRef(null);  //it to when there is  lot of message then it will autonmatically scroll to down,it is react tool
  useEffect(() => {
    if (chatId) {   //to catch particular group chat using id
      db.collection("chats") //db is data base so that our chat get store in database
        .doc(chatId)
        .collection("messages")//acess messages
        .orderBy("timestamp", "asc")
        .onSnapshot(snapshot =>
          setMessages(
            snapshot.docs.map(doc => {
              return {
                id: doc.id,
                data: doc.data()
              };
            })
          )
        );
    }
  }, [chatId]);
  const sendMessage = e => {
    e.preventDefault();
    //firebase magic
    //to collect chat
    if (input) {     //this is to  send message and it will factch all  info from input
      db.collection("chats")
        .doc(chatId)
        .collection("messages")
        .add({
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          message: input,
          uid: user.uid,
          photo: user.photo,  //to get avtar of user form google account
          email: user.email,
          displayName: user.displayName
        });
        //after sending message input will get empty
      setInput("");
      ref.current.scrollTo(0, ref.current.scrollHeight + 100);     //scroll 
    }
  };
  return (
    <div className="chat">
      <div className="chat__header">
        {matches && <MenuIcon onClick={handleOpen} />}
        <h4>
          To: <span className="chat__name">{chatName || "Select Chats"}</span>
        </h4>
      </div>
      <div className="chat__messages" ref={ref}>
      {/*IT IS REACT FLIP MOVE LIBRARY  to make chat message animation */}
        <FlipMove> 
          {messages.map(({ id, data }) => {
            return <Message key={id} id={id} contents={data} />;
          })}
        </FlipMove>
      </div>
      <div className="chat__input">
        <form>
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            type="text"
            placeholder="Send Message"
          ></input>
          <button type="submit" onClick={sendMessage}>
            Send Message
          </button>
        </form>
       {/*using this we can send message using icon as well as using send button which if not visible */}
        <IconButton type="submit" onClick={sendMessage} >
          <SendIcon className='chat__mic' />
        </IconButton> 
      
      </div>
    </div>
  );
};

export default Chat;
